import axios from 'axios';
import TokenStorage from './token-storage';
import { ROOT_API } from './constants/env';
import Logger from '@/lib/logger';
import router from '@/router/index';
// import { AuthService } from '@/modules/auth/services/auth.service';

const defaultOptions = {
  baseURL: ROOT_API
};

class Http {
  _options;
  _instance;

  constructor(opts = defaultOptions) {
    this._options = opts;

    let token = TokenStorage.getToken();

    //Add X-Tenant-ID header
    this._options.headers = {
      ...this._options.headers,
      'X-TENANT-ID': window.location.hostname
    };

    if (token) {
      this._options.headers = {
        ...this._options.headers,
        Authorization: `Bearer ${token}`
      };
    }

    this._instance = axios.create(this._options);

    //Response interceptor
    this._instance.interceptors.response.use(
      function (response) {
        const { status, data } = response;
        return { status, data };
      },
      async function (error) {
        const { response } = error;

        if (response) {
          Logger.error('Response error: ', response);

          if (response.status === 401) {
            const store = (await import('@/store')).default;
            const user = store.getters['authModule/user'];
            if (user) {
              const AuthService = (
                await import('@/modules/auth/services/auth.service')
              ).AuthService;
              const service = new AuthService();
              await service.signOut(user?.id);
            }
            // Handle unauthorized access
            // Clear tokens
            TokenStorage.removeToken();
            TokenStorage.removeRefreshToken();
            // Redirect to login page if they are not already there
            if (router.currentRoute.path !== '/auth/login') {
              // Redirect to login page
              router.push('/auth/login');
            }
          }
        } else {
          Logger.info('Network error: ', error);
        }

        return Promise.reject(error);
      }
    );
  }

  httpClient() {
    return this._instance;
  }
}

const responseErrorHelper = (error) => {
  const { response, request } = error;
  if (response) {
    Logger.error('response error: ', request, response);
    const { status, data } = response;
    if (status == 409) {
      return `<strong>Conflict</strong>! ${data.error.message}`;
    }
  } else if (request) {
    Logger.info('network error: ', request);
    return '<strong>The network is abnormal</strong> please check your network';
  } else {
    Logger.info('unknown error: ', error);
    return '<strong>Unknown issue</strong>. Please try again.';
  }
};

export { Http, responseErrorHelper };
